var map = {
	"./amulogo.png": "e46a",
	"./car.png": "b867",
	"./house.svg": "810f",
	"./logo.png": "ef82",
	"./rupee.svg": "ed71",
	"./star-half-wide.svg": "2638",
	"./team-solid.svg": "d560"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a963";